import { render, staticRenderFns } from "./SubscriptionPlansAdmin.vue?vue&type=template&id=3a065e90&scoped=true"
import script from "./SubscriptionPlansAdmin.vue?vue&type=script&lang=js"
export * from "./SubscriptionPlansAdmin.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionPlansAdmin.vue?vue&type=style&index=0&id=3a065e90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a065e90",
  null
  
)

export default component.exports